import { gql } from '@apollo/client'

export const POOLS_QUERY = gql`
  query pools($sortBy: PoolSort, $filter: PoolFilter) {
    pools(sortBy: $sortBy, filter: $filter) {
      collection {
        id
        name
        archived
      }
    }
  }
`
